import createIcon from '../../createIcon';

/**
 * @component @name EditRoad
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNDk5IDRIMTQuNDk5VjExLjlMMTYuNDk5IDkuOVY0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQuNDk5MDIgNEgyLjQ5OTAyVjIwSDQuNDk5MDJWNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMC40OTkgNEg4LjQ5OTAyVjhIMTAuNDk5VjRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTAuNDk5IDEwSDguNDk5MDJWMTRIMTAuNDk5VjEwWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwLjQ5OSAxNkg4LjQ5OTAyVjIwSDEwLjQ5OVYxNloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMS4wNTkgMTIuNTlMMTkuOTA5IDExLjQ0QzE5LjMxOSAxMC44NSAxOC4zNjkgMTAuODUgMTcuNzg5IDExLjQ0TDEyLjQ5OSAxNi43M1YyMEgxNS43NjlMMjEuMDU5IDE0LjcxQzIxLjY0OSAxNC4xMiAyMS42NDkgMTMuMTcgMjEuMDU5IDEyLjU5Wk0xNS4wNzkgMTguNDVIMTQuMDQ5VjE3LjQyTDE3LjQ5OSAxMy45N0wxOC41MjkgMTVMMTUuMDc5IDE4LjQ1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EditRoad = createIcon('EditRoad', [
  ['path', { d: 'M16.499 4H14.499V11.9L16.499 9.9V4Z', key: '1jnyoi' }],
  ['path', { d: 'M4.49902 4H2.49902V20H4.49902V4Z', key: 'd3cjyz' }],
  ['path', { d: 'M10.499 4H8.49902V8H10.499V4Z', key: 'blh6p7' }],
  ['path', { d: 'M10.499 10H8.49902V14H10.499V10Z', key: '1wfbzw' }],
  ['path', { d: 'M10.499 16H8.49902V20H10.499V16Z', key: '1mqioy' }],
  [
    'path',
    {
      d: 'M21.059 12.59L19.909 11.44C19.319 10.85 18.369 10.85 17.789 11.44L12.499 16.73V20H15.769L21.059 14.71C21.649 14.12 21.649 13.17 21.059 12.59ZM15.079 18.45H14.049V17.42L17.499 13.97L18.529 15L15.079 18.45Z',
      key: 'ipvwi3',
    },
  ],
]);

export default EditRoad;
